module.exports = __webpack_public_path__ + "imgesssyaa/svg/infography.5d1e903d.svg";